import { useQuery } from '@tanstack/react-query';

import { IntentService } from 'src/utils/api';

export function useFileUrls(intentId: string) {
  const { data, isPending } = useQuery({
    queryKey: ['file-urls', intentId],
    queryFn: () => IntentService.getFileUrls(intentId),
    enabled: !!intentId,
    staleTime: (60 - 5) * 60 * 1000, // Consider data stale after 55 minutes, similar to presigned URL
  });

  return {
    fileUrls: data?.file_urls || [],
    intentMetadata: data?.intent_metadata || {},
    isPending,
  };
}
